import React from "react";
import {toast} from "react-toastify";
import "./Toast.scss";
import "./InfoToast.scss";
import {ToastBody} from "./ToastBody";
import {type ToastHandler} from "./types";

export const showInfoToast: ToastHandler = ({id, title = "Information", message, link, when}) =>
  toast.info(<ToastBody title={title} message={message} link={link} when={when} />, {
    closeButton: false,
    icon: false,
    toastId: id
  });
